// extracted by mini-css-extract-plugin
export default {"rootContainer":"SelectProductItemsModal_rootContainer__NkHgI"};